export default __webpack_public_path__ + "static/media/1775.43ce44c1.png";